import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Book = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <path
        d="M2 12.6711V3.33389C2 2.59692 2.59692 2 3.33389 2H12.0042C12.7411 2 13.3381 2.59692 13.3381 3.33389V10.0033C13.3381 10.7403 12.7411 11.3372 12.0042 11.3372H3.33389C2.59692 11.3372 2 11.9341 2 12.6711V12.6711C2 13.4081 2.59692 14.005 3.33389 14.005H12.0042C12.7411 14.005 13.3381 13.4081 13.3381 12.6711V9.33639"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6705 5.10593H4.66797"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Book.propTypes = {
  color: PropTypes.string
};

Book.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default Book;
